__turbopack_context__.v({
  "badge": "CartIcon-module-scss-module__QcudvG__badge",
  "cartSvg": "CartIcon-module-scss-module__QcudvG__cartSvg",
  "iconWrap": "CartIcon-module-scss-module__QcudvG__iconWrap",
  "wrap": "CartIcon-module-scss-module__QcudvG__wrap",
});
